import { Amount as Amount$1 } from './component.js';
import { PureAmount } from './pure/component.js';
import 'react';
import 'classnames';
import '@alfalab/utils';
import './utils/logWarning.js';
import './utils/trimTrailingZeros.js';

var Amount = Amount$1;
Amount.Pure = PureAmount;

export { Amount, Amount$1 as AmountComponent, PureAmount as Pure };
